import { useContext, useLayoutEffect, useRef, useState } from "react";
import { ProgressBar, Tab, Tabs } from "react-bootstrap";
import { ReactComponent as RouteIcon } from "../../../../../asset/icons/customer-club-route-icon.svg";
import { ReactComponent as BackIcon } from "../../../../../asset/icons/backIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../../../asset/icons/downloadIcon.svg";
import TableFileBox from "../../../../../component/global/TableFileBox";
import AddUser from "./AddUser";
import AddGroup from "./AddGroup";
import "./style.scss";
import {
    EXPORT_CLUB_USERS,
    IMPORT_CLUB_USERS,
} from "../../../../../helperData/ApiAddress";
import axios from "axios";
import { ToastContext } from "../../../../../component/global/ToastContext";
import { useTranslation } from "react-i18next";

export default function NewUserModal({
    onHide,
    changeRefreshValue,
    editMode,
    itemId,
}) {
    const [activeTab, setActiveTab] = useState();
    const [file, setFile] = useState();
    const [link, setLink] = useState();
    const downloadLink = useRef();
    const backRef = useRef(null);
    const show = useContext(ToastContext);
    const {
        t,
        i18n: { dir, language },
    } = useTranslation();

    useLayoutEffect(() => {
        const btn = backRef.current;
        if (dir(language) === "ltr") {
            btn.style.transform = "rotate(180deg)";
        } else {
            btn.style.removeProperty("transform");
        }
    }, [dir, language]);

    const exportClubUsers = () => {
        axios
            .get(EXPORT_CLUB_USERS, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${window.sessionStorage.auth}`,
                },
            })
            .then((response) => {
                let blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "export.xlsx");
                document.body.appendChild(link);
                link.click();
            });
    };

    const [uploadProgress, setUploadProgress] = useState(0);
    const [excelError, setExcelError] = useState("");
    const [excelFile, setExcelFile] = useState("");

    const importClubUsers = () => {
        setExcelError("");
        setUploadProgress(0);
        let formData = new FormData();
        formData.append("file", excelFile);
        axios
            .post(IMPORT_CLUB_USERS, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${window.sessionStorage.auth}`,
                    "Content-Disposition": "attachment; filename=file",
                },
                onUploadProgress: (ProgressEvent) => {
                    const { loaded, total } = ProgressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                },
            })
            .then((r) => {
                setExcelFile("");
                setUploadProgress(0);
                show(
                    t(
                        "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.Index.Success"
                    ),
                    "success"
                );
                onHide();
                changeRefreshValue();
            })
            .catch((e) => {
                setExcelError(
                    t(
                        "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.Index.Danger"
                    )
                );
                setUploadProgress(0);
            });
    };

    return (
        <>
            <div className="modal-title">
                <div className="title-box">
                    <RouteIcon />
                    <span>
                        {editMode
                            ? t(
                                  "Organizational.CustomerClub.AddAMember.Edit.Title"
                              )
                            : t(
                                  "Organizational.CustomerClub.AddAMember.Add.Title"
                              )}
                    </span>
                </div>
                <button ref={backRef} onClick={onHide}>
                    <BackIcon />
                </button>
            </div>
            <div className="tab-section">
                <Tabs
                    activeKey={activeTab}
                    transition={false}
                    className="panel_tab"
                    onSelect={(e) => setActiveTab(e)}
                >
                    <Tab
                        eventKey="1"
                        className="panel_tab_item"
                        title={
                            editMode
                                ? t(
                                      "Organizational.CustomerClub.AddAMember.Edit.Title"
                                  )
                                : t(
                                      "Organizational.CustomerClub.AddAMember.Tab"
                                  )
                        }
                    >
                        <AddUser
                            changeRefreshValue={changeRefreshValue}
                            hideModal={onHide}
                            editMode={editMode}
                            itemId={itemId}
                        />
                    </Tab>
                    {editMode === false && (
                        <Tab
                            eventKey="2"
                            className="panel_tab_item"
                            title={t(
                                "Organizational.CustomerClub.AddMemberByGroup.Tab"
                            )}
                        >
                            <div className="file-upload-row">
                                <label></label>
                                <TableFileBox
                                    changeFunction={(e) =>
                                        setExcelFile(e.target.files[0])
                                    }
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    value={excelFile.name}
                                />
                                <div className="progress-section">
                                    {uploadProgress > 0 && (
                                        <>
                                            <div>
                                                {t(
                                                    "Organizational.CustomerClub.AddMemberByGroup.Upload.File"
                                                )}
                                            </div>
                                            <ProgressBar now={uploadProgress} />
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="download-section">
                                <div className="btn-row">
                                    <div className="btn-group">
                                        <button
                                            className=" blue"
                                            onClick={importClubUsers}
                                        >
                                            {t(
                                                "Organizational.CustomerClub.Send.Button"
                                            )}
                                        </button>
                                    </div>
                                </div>
                                <a
                                    className="download-btn download-link-file"
                                    onClick={exportClubUsers}
                                >
                                    <DownloadIcon />
                                    <span>
                                        {t(
                                            "Organizational.CustomerClub.RawFileDownload.Button"
                                        )}
                                    </span>
                                </a>
                            </div>
                            <div className="excel-error">{excelError}</div>
                        </Tab>
                    )}
                    {editMode === false && (
                        <Tab
                            eventKey="3"
                            className="panel_tab_item"
                            title={t(
                                "Organizational.CustomerClub.AddANewGroup.Tab"
                            )}
                        >
                            <AddGroup />
                        </Tab>
                    )}
                </Tabs>
            </div>
        </>
    );
}
